/** @jsxImportSource @emotion/react */
import {
  AlignItems,
  Box,
  Color,
  FontFamily,
  Icon,
  IconProps,
  IconVariant,
  LinkVariant,
  Paragraph,
  Space,
} from '@gousto-internal/citrus-react'
import { FALLBACK_COLOR, FALLBACK_ICON } from 'src/config/icons'
import { client } from 'src/config/routes'
import { Link } from '../../Routing'
import { ErrorBoundary } from '../../ErrorBoundary'

interface OtherTopicProps {
  id: number
  iconName?: IconProps['name']
  iconColour: string
  name: string
  nameSlug: string
}

const OtherTopic = ({
  id, iconName, iconColour, name, nameSlug,
}: OtherTopicProps) => (
  (
    <Link
      href={`/help-centre${client.categories}/${nameSlug}/${id}`}
      variant={LinkVariant.None}
      css={{ display: 'block', textDecoration: 'none' }}
      key={id}
    >
      <Box
        display="flex"
        alignItems={AlignItems.Center}
        paddingV={6}
      >
        <ErrorBoundary fallBackUI={(
          <Icon
            name={FALLBACK_ICON}
            css={{ color: iconColour }}
            size={6}
          />
        )}
        >
          <Icon
            name={iconName || FALLBACK_ICON}
            css={{ color: iconColour || FALLBACK_COLOR }}
            size={6}
          />
        </ErrorBoundary>
        <Space direction="horizontal" size={3} />
        <Paragraph
          fontFamily={FontFamily.SemiBold}
          color={Color.ColdGrey_800}
        >
          {name}
        </Paragraph>
        <Icon
          name="chevron_right"
          variant={IconVariant.Actionable}
          css={{ marginLeft: 'auto' }}
        />
      </Box>
    </Link>
  )
)

export { OtherTopic }
